<template>
  <div class="card bg-light mb-3 border-0 p-10">
    <div class="card-body custom-card-body">
      <div class="row align-items-center status-row" style="margin-bottom: 15px;">
        <div class="col-4 text-left pd">
          <strong class="font-primary">{{$t('ş_')}}</strong>
          <span class="font-primary" style="margin-left:4px;">
            {{ data.dispClaimNumber }}
          </span>
        </div>
        <div class="col-6 pd status-value-col">
          <status-label class="claim-status" style="font-size:8px; margin-right:8px;"
            :type="getStatusColor(data.statusTypeId)" />
          <span class="status-name font-primary" style="font-weight:bold;">
            {{ data.statusTypeName }}
          </span>
        </div>
        <div class="col-2 text-right">
          <el-dropdown trigger="click" :title="$t('Ləğv_et')" @command="handleCommand" @click.native.stop>
            <el-button type="text" class="custom-button" style="padding: 0 !important;" @click.stop>
              <div class="square-icon">
                <i class="fas fa-ellipsis-h" style="color: #808080;"></i>
              </div>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{ action: 'delete', id: data.id }" class="dropdown-item">
                <i class="fa-solid fa-trash-can"></i>
                <span>{{$t('Ləğv_et')}}</span>
              </el-dropdown-item>
              <el-dropdown-item @click.native.stop class="dropdown-item">
                <span @click="handleCommand({ action: 'sendMessage', id: linkid })">
                  <i class="fa-solid fa-wrench"></i>
                  <span>{{$t('Tənzimlənmə')}}</span>
                </span>
              </el-dropdown-item>
              <el-dropdown-item @click.native.stop class="dropdown-item">
                <span @click="handleCommand({ action: 'sendSms', id: linkid })">
                  <i class="fa-solid fa-sms"></i>
                  <span>{{$t('Sms_Göndər')}}</span>
                </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      
      <div class="section">
        <titles :text="$t('Zərər_vuran')" />
        <hr class="section-divider" />
        <div class="row">
          <div class="col-4 text-left pd">
            <strong class="font-primary">{{$t('A.S.A')}}:</strong>
          </div>
          <div class="col-8 pd font-primary">
            {{ data.partPersonName }}
          </div>

          <div v-if="data.insuranceTypeName !== 'N/A'" class="col-4 text-left pd">
            <strong class="font-primary">{{$t('Sığorta_növü')}}:</strong>
          </div>
          <div v-if="data.insuranceTypeName !== 'N/A'" class="col-8 pd font-primary">
            {{ data.insuranceTypeName }}
          </div>

          <div v-if="data.policyType === 1" class="col-4 text-left pd">
            <strong class="font-primary">{{$t('Zərər_növü')}}:</strong>
          </div>
          <div v-if="data.policyType === 1" class="col-8 pd font-primary">
            {{ data.damageTypeName }}
          </div>

          <div v-if="data.policyType === 1 && data.damageType === 1" class="col-4 text-left pd">
            <strong class="font-primary">{{$t('NV_məlumat')}}:</strong>
          </div>
          <div v-if="data.policyType === 1 && data.damageType === 1" class="col-8 pd font-primary">
            {{ formatInsCarInfo(data.regNumber, data.brandModel) }}
          </div>

          <div v-if="data.policyType === 1 && data.damageType === 3" class="col-4 text-left pd">
            <strong class="font-primary">{{$t('Əmlak_adı')}}:</strong>
          </div>
          <div v-if="data.policyType === 1 && data.damageType === 3" class="col-8 pd font-primary">
            {{ formatInsPropertyName(data.otherPropertyName) }}
          </div>
        </div>
      </div>

      <div class="section" style="margin-top:10px;">
        <titles :text="$t('Zərər_çəkən')" />
        <hr class="section-divider" />
        <div v-if="data.osId" class="row">
          <div class="col-4 text-left pd">
            <strong class="font-primary">{{$t('A.S.A')}}:</strong>
          </div>
          <div class="col-8 pd font-primary">
            {{ data.osPartPersonName }}
          </div>

          <div v-if="data.osInsuranceType" class="col-4 text-left pd">
            <strong class="font-primary">{{$t('Sığorta_növü')}}:</strong>
          </div>
          <div v-if="data.osInsuranceType" class="col-8 pd font-primary">
            {{ data.osInsuranceTypeName }}
          </div>

          <div v-if="data.policyType === 1" class="col-4 text-left pd">
            <strong class="font-primary">{{$t('Zərər_növü')}}:</strong>
          </div>
          <div v-if="data.policyType === 1" class="col-8 pd font-primary">
            {{ data.osDamageTypeName }}
          </div>

          <div v-if="data.policyType === 1 && data.osDamageType === 1" class="col-4 text-left pd">
            <strong class="font-primary">{{$t('NV_məlumat')}}:</strong>
          </div>
          <div v-if="data.policyType === 1 && data.osDamageType === 1" class="col-8 pd font-primary">
            {{ formatOsCarInfo(data.osRegNumber, data.osBrandModel) }}
          </div>

          <div v-if="data.policyType === 1 && data.osDamageType === 3" class="col-4 text-left pd">
            <strong class="font-primary">{{$t('Əmlak_adı_1')}}</strong>
          </div>
          <div v-if="data.policyType === 1 && data.osDamageType === 3" class="col-8 pd font-primary">
            {{ formatOsPropertyName(data.osOtherPropertyName) }}
          </div>
        </div>
        <div v-else class="col-12 pd">
          <h4>{{$t('Yoxdur')}}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StatusLabel from "./StatusLabel.vue";
  import {
    SendToTechExpert,
    SendToLegalExpert,
    GetClaimAct,
    FinishTechExpert,
  } from "../../services/claim";
  import { SendToMedExpert, CheckStatusCount } from "../../services/common";
  import Titles from "./Titles.vue";
  import { trackerUrl, textLeft } from "../../services/helper";
  export default {
    components:
    {
      StatusLabel,
      Titles
    },
    props: {
      item: Object,
      readonly: { type: Boolean, default: true },
      linkid: String
    },
    data() {
      return {
        data: this.item,
        act: [],
        uid: this.$store.state.user.id,
        statusCount: 0,
        disabled: this.readonly,
        roles: this.$store.state.user.roles,
        textLeft: textLeft,

      };
    },
    methods: {
      getStatusColor(statusId) {
        const statusColors = {
          45: 'indigo',
          50: 'forestGreen',
          70: 'goldenrod',
          75: 'limeGreen',
          80: 'mediumBlue',
          95: 'greenYellow',
          110: 'coral',
          140: 'salmon',
          130: 'olive',
          160: 'lightblue',
          150: 'forestGreen',
          152: 'red',
          153: 'red'
        };
        return statusColors[statusId] || '';
      },
      formatOsCarInfo(osRegNumber, osBrandModel) {
        let result = "";
        if (osRegNumber) {
          result += osRegNumber;
        }
        if (osRegNumber && osBrandModel) {
          result += ", ";
        }
        if (osBrandModel) {
          result += osBrandModel;
        }
        return result;
      },
      formatOsPropertyName(osOtherPropertyName) {
        return osOtherPropertyName ? (osOtherPropertyName) : "";
      },
      formatInsPropertyName(otherPropertyName) {
        return otherPropertyName ? ("Əmlak adı: " + otherPropertyName) : "";
      },
      // formatInsCarInfo(data) {
      //   console.log(data);
      //   let parts = [];
      //   if (data.regNumber) parts.push(data.regNumber);
      //   if (data.brandModel) parts.push(data.brandModel);
      //   console.log(parts);
      //   return parts.join(", ");
      // },
      formatInsCarInfo(regNumber, brandModel) {
        let result = "";
        if (regNumber) {
          result += regNumber;
        }
        if (regNumber && brandModel) {
          result += ", ";
        }
        if (brandModel) {
          result += brandModel;
        }
        return result;
      },
      // formatInsPropertyInfo(data) {
      //   let parts = [];
      //   if (data.otherPropertyNumber) parts.push(data.otherPropertyNumber);
      //   if (data.otherProperty) parts.push(data.otherProperty);
      //   return parts.join(" / ");
      // },
      handleCommand(command) {
        let id = command.id;
        // if (command.action === "edit") this.handleEdit(id);
        if (command.action === "delete") this.handleDelete(id);
        else if (command.action === "sendMessage") this.handleSendMessage(command.id);
        else if (command.action === "techexpert") this.handleTechExpert(id);
        else if (command.action === "medexpert") this.handleMedExpert(id);
        else if (command.action === "legalexpert") this.handleLegalExpert(id);
        this.getClaimAct(id);
      },
      handleSendMessage(id) {
        if (id) {
          window.open(`${trackerUrl}${id}`, '_blank');
        } else {
          this.$message({
            type: "warning",
            message: "Public link is not available",
          });
        }
      },
      checkStatusCount(id, status) {
        this.statusCount = 0;
        return new Promise((resolve, reject) => {
          CheckStatusCount(0, id, status).then((response) => {
            if (response.data.data) {
              this.statusCount = response.data.data;
            }
            resolve(this.response);
          }, error => {
            reject(error);
          })
        })
      },
      // handleEdit(id) {
      //   this.$router.push({
      //     path: "../claim/" + id,
      //   });
      // },
      handleDelete(id) {
        this.$emit("delete", id);
      },
      handleTechExpert(id) {
        this.checkStatusCount(id, 70).then(() => {
          if (this.statusCount > 0) {
            this.$message({
              type: "warning",
              message: this.$t('Daha_öncə_qiymətləndirməyə_göndərilib'),
            });
          }
          else {
            this.$confirm(this.$t('Qiymətləndirməyə_göndərilsin'), this.$t('Təsdiqləyin'), {
              confirmButtonText: this.$t('Bəli'),
              cancelButtonText: this.$t('Xeyr'),
              type: "info",
            })
              .then(() => {
                this.loading = true;
                SendToTechExpert(id, this.uid).then((response) => {
                  this.loading = false;
                  if (response.data.data) {
                    if (!response.data.isSuccess) {
                      this.$message({
                        type: "error",
                        message: response.data.data.errors[0],
                      });
                    } else {
                      this.$message({
                        type: "success",
                        message: this.$t('Qiymətləndirməyə_göndərildi'),
                      });
                      this.$emit("refresh");
                    }
                  } else {
                    this.$message({
                      type: "error",
                      message: this.$t('Səhv_əməliyyat'),
                    });
                  }
                });
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: "info",
                  message: "Xitam verildi",
                });
              });
          }
        });
      },
      handleMedExpert(id) {
        this.checkStatusCount(id, 138).then(() => {
          if (this.statusCount > 0) {
            this.$message({
              type: "warning",
              message: this.$t('Daha_öncə_Tibbi_ekspertizaya_göndərilib'),
            });
          }
          else {
            this.$confirm(this.$t('Tibbi_ekspertizaya_göndərilsin'), this.$t('Təsdiqləyin'), {
              confirmButtonText: this.$t('Bəli'),
              cancelButtonText: this.$t('Xeyr'),
              type: "info",
            })
              .then(() => {
                this.loading = true;
                SendToMedExpert(id, this.uid).then((response) => {
                  this.loading = false;
                  if (response.data.data) {
                    if (!response.data.isSuccess) {
                      this.$message({
                        type: "error",
                        message: response.data.data.errors[0],
                      });
                    } else {
                      this.$message({
                        type: "success",
                        message: this.$t('Tibbi_ekspertizaya_göndərildi'),
                      });
                      this.$emit("refresh");
                    }
                  } else {
                    this.$message({
                      type: "error",
                      message: this.$t('Səhv_əməliyyat'),
                    });
                  }
                });
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: "info",
                  message: "Xitam verildi",
                });
              });
          }
        });
      },
      handleLegalExpert(id) {

        this.checkStatusCount(id, 145).then(() => {
          if (this.statusCount > 0) {
            this.$message({
              type: "warning",
              message: this.$t('Daha_öncə_Hüquqi_ekspertizaya_göndərilib'),
            });
          }
          else {
            this.$confirm(this.$t('Hüquqi_ekspertizaya_göndərilsin'), this.$t('Təsdiqləyin'), {
              confirmButtonText: this.$t('Bəli'),
              cancelButtonText: this.$t('Xeyr'),
              type: "info",
            })
              .then(() => {
                if (!this.act.bankAccount) {
                  this.$message({
                    type: "error",
                    message: this.$t('Hesab_məlumatları_qeyd_edilməyib'),
                  });
                }
                else {
                  this.loading = true;
                  SendToLegalExpert(id, this.uid).then((response) => {
                    this.loading = false;
                    if (response.data.data) {
                      if (!response.data.isSuccess) {
                        this.$message({
                          type: "error",
                          message: response.data.data.errors[0],
                        });
                      } else {
                        this.$message({
                          type: "success",
                          message: this.$t('Hüquqi_ekspertizaya_göndərildi'),
                        });
                        this.$emit("refresh");
                      }
                    } else {
                      this.$message({
                        type: "error",
                        message: this.$t('Səhv_əməliyyat'),
                      });
                    }
                  });
                }

              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: "info",
                  message: "Xitam verildi",
                });
              });
          }
        });
      },
      handleFinish(id) {
        this.checkStatusCount(id, 140).then(() => {
          if (this.statusCount > 0) {
            this.$message({
              type: "warning",
              message: this.$t('Daha_öncə_Müştəri_xidmətlərinə_göndərilib'),
            });
          } else {
            this.$confirm(this.$t('ş_müştəri_xidmətlərinə_göndərilsin'), this.$t('Təsdiqləyin'), {
              confirmButtonText: this.$t('Bəli'),
              cancelButtonText: this.$t('Xeyr'),
              type: "info",
            }).then(() => {
              this.loading = true;
              FinishTechExpert(id, this.uid).then((response) => {
                this.loading = false;
                if (response.data.data) {
                  if (!response.data.isSuccess) {
                    this.$message({
                      type: "error",
                      message: response.data.data.errors[0],
                    });
                  } else {
                    this.$message({
                      type: "success",
                      message: this.$t('Uğurlu_əməliyyat'),
                    });
                    this.$emit("refresh");
                  }
                } else {
                  this.$message({
                    type: "error",
                    message: this.$t('Səhv_əməliyyat'),
                  });
                }
              });
            });
          }
        });
      },

      getClaimAct(id) {
        GetClaimAct(id).then((response) => {
          if (response.data.data) {
            this.act = response.data.data;
          }
        });
      },
    },
    watch: {
      item() {
        this.data = this.item;
      },
      readonly() {
        this.disabled = this.readonly;
      },
    },
    mounted() {
    }
  };
</script>

<style>
  .status-row {
    margin-bottom: 15px;
  }

  /* Label kolonu (col-4) */
  .status-label-col .label-text {
    font-size: 12px;
    font-weight: bold;
    color: #3A3A3A;
  }

  /* Value kolonu (col-8) içi flex */
  .status-value-col {
    display: flex;
    align-items: center;
    /* Dikey ortala */
    white-space: nowrap;
    /* Tek satır */
    overflow: hidden;
    margin-left: -15px;
  }

  /* Claim Number */
  .status-value-col .claim-number {
    font-size: 12px;
    color: #3A3A3A;
    margin-right: 0.75rem;
    /* İkon ile arada boşluk */
  }

  /* Status icon */
  .status-value-col .claim-status {
    font-size: 8px !important;
    margin: 0 0.5rem;
    /* Solda & sağda boşluk */
  }

  /* Status name */
  .status-value-col .status-name {
    font-size: 12px;
    font-weight: bold;
    color: #3A3A3A;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  /* Section başlık alt çizgisi */
  .section-divider {
    width: 95%;
    height: 1px;
    background: #F3EFE0;
    margin: 5px 0 10px;
    border: none;
  }

  /* Genel satır içi metin */
  .pd {
    font-size: var(--font-primary);
    color: #3A3A3A;
  }

  .custom-card-body {
    padding: 15px 0 10px 15px !important
  }

  .dropdown-item {
  color: #3A3A3A; 
}

.dropdown-item i {
 color: var(--font-primary) !important;
}

.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:focus {
  background-color: #f5f7fa;
  color: #409EFF; /* Mavi hover efekti */
}
</style>